// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import CheckboxRadio from 'vue-checkbox-radio'
import VModal from 'vue-js-modal'
import VueGtm from 'vue-gtm'
import VueCookie from 'vue-cookie'
import Cookies from './components/cookies'

let gdprCookie = Cookies.getCookie('gdpr')
let gtmAllowed = false
if (gdprCookie) {
  try {
    gtmAllowed = JSON.parse(gdprCookie)['preferential_cookies'] === '1'
  } catch (e) {
    console.log(e.message)
  }
}

Vue.use(CheckboxRadio)
Vue.use(VModal, { dialog: true })
Vue.use(VueCookie)
Vue.use(VueGtm, {
  enabled: gtmAllowed, // Whether or not display console logs debugs (optional)
  debug: true, // Whether or not display console logs debugs (optional)
  vueRouter: router // Pass the router instance to automatically sync with router (optional)
  // ignoredViews: ['homepage'], // If router, you can exclude some routes name (case insensitive) (optional)
})

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js